<template>
    <div class="panel-header">
        <span v-if="!isOffline" class="panel-header__is-live">
            {{ $t('twitch.globalMsg.live') }}
        </span>
        <img src="@RepoAsset/icons/icon-logo-voicemod.svg">
    </div>
</template>

<script>
export default {
    props: {
        isOffline: {
            Type: Boolean,
            required: true,
        },
    },
};
</script>

<style src="./PanelHeader.scss" lang="scss" scoped></style>
